import axios from './axios';

// 取得單一公告
export function getAnnouncementById(id) {
    return axios.get(`/api/announcements/${id}`).then(res => res.data);
}

// 取得分頁公告（動態查詢條件）
export function getAnnouncementPage(params) {
    return axios.get('/api/announcements/page', { params }).then(res => res.data);
}

// 建立公告
export function createAnnouncement(announcement) {
    return axios.post('/api/announcements', announcement).then(res => res.data);
}

// 更新公告
export function updateAnnouncement(id, announcement) {
    return axios.put(`/api/announcements/${id}`, announcement).then(res => res.data);
}

// 刪除公告
export function deleteAnnouncement(id) {
    return axios.delete(`/api/announcements/${id}`).then(res => res.status === 200 || res.status === 204);
}
